import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import ServicesPage from '@/pages/services/page';
import CoursesPage from '@/pages/courses/page';
import AboutPage from '@/pages/about/page';
import ContactPage from '@/pages/contact/page';
import PrivacyPolicyPage from '@/pages/privacy-policy/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/courses', element: <CoursesPage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/privacy-policy', element: <PrivacyPolicyPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
